module.exports = "./assets/images/avatar-14.svg";